import { type ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';
import type { Cfg } from '../hooks/use-settings-state';
import { RaceBonusHistory } from './race-bonus-history';
import { RaceCycleBlock } from './settings-race-cycle';

type Set = (k: keyof Cfg, v: string | number | boolean) => void;

function HistoryCollapsible(): ReactNode {
  return (
    <details className="col-span-full">
      <summary className="flex cursor-pointer list-none items-center gap-xs text-[11px] text-text-tertiary hover:text-text-secondary [&>svg]:open:rotate-180">
        <ChevronDown size={12} className="transition-transform" />
        Historico de carreras
      </summary>
      <div className="mt-sm">
        <RaceBonusHistory />
      </div>
    </details>
  );
}

export function RaceSection({ cfg, set }: { cfg: Cfg; set: Set }): ReactNode {
  return (
    <>
      <RaceCycleBlock cycle="daily" cfg={cfg} set={set} />
      <RaceCycleBlock cycle="weekly" cfg={cfg} set={set} />
      <RaceCycleBlock cycle="monthly" cfg={cfg} set={set} />
      <HistoryCollapsible />
    </>
  );
}
